import { createRouter, createWebHistory } from 'vue-router';
import BaseLayout from '@/components/BaseLayout.vue';
import HomeView from '@/views/HomeView.vue';

// i18nのインスタンスを後で設定
let i18nInstance = null;


const supportedLangs = ['ja', 'en'];
const vueI18nLangs = {};


const routes = [
  {
    path: '/:lang/',
    component: BaseLayout,
    children: [
      {
        path: '',
        name: 'home',
        component: HomeView
      }
    ],
  },
  {
    path: '/',
    redirect: '/ja/'
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/ja/'
  }
];

const router = createRouter({
  history: createWebHistory('/natadera/'),
  routes
});

router.beforeEach((to, from, next) => {
  // パスから言語を抽出
  const pathSegments = to.path.split('/');
  const lang = pathSegments[1];
  
  // サポートされている言語かチェック
  if (supportedLangs.includes(lang)) {
    if (i18nInstance) {
      i18nInstance.global.locale.value = lang;
    }
    next();
  } else {
    // 言語が指定されていない場合は日本語にリダイレクト
    next('/ja/');
    return;
  }
});

// i18nインスタンスを設定する関数をエクスポート
export const setI18nInstance = (i18n) => {
  i18nInstance = i18n;
};

export default router;
